/* THTD e-mail capture popup — jeden <dialog>, kontextová copy, frekvence 1×/30 dní,
 * nikdy po přihlášení k odběru, nepřekrývá jiný <dialog> (lokalizace/košík). Vanilla, defer.
 * Sourozenec thtd-localize.js — stejný pattern showModal()/backdrop/close.
 */
(function () {
  'use strict';

  var SEEN_KEY = 'thtd_ec_seen'; // timestamp posledního zobrazení (ms)
  var SUB_KEY = 'thtd_ec_sub';   // '1' = už odebírá → nikdy znovu
  var COOLDOWN = 7 * 24 * 60 * 60 * 1000; // 7 dní (po zavření bez přihlášení)
  var openTries = 0;
  // Test režim (?ec_test=1): ignoruj frekvenční cap i „už odebírá", nic neukládej,
  // naskoč hned — pro náhled/QA. Pro reálné návštěvníky beze změny.
  var TEST = /[?&]ec_test=1/.test(window.location.search);

  function ls(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function modalEl() { return document.querySelector('[data-thtd-ec-modal]'); }

  var GA4_ID = 'G-CCFJS161KM'; // = property Google & YouTube appky (viz web pixel config)
  var META_PIXEL_ID = '1142870909058239'; // = dataset „Facebook pixel SHPY" (Meta appka)

  /* GA4 custom event „newsletter_signup" po úspěšném přihlášení.
   * gtag z Google & YouTube appky běží v sandboxu Shopify web pixels — hlavní okno
   * na něj nedosáhne a appka custom eventy nepřeposílá. Proto si gtag.js nahrajeme
   * sami, LAZY až v momentě úspěchu (běžné návštěvy nic nestojí) a se
   * send_page_view:false (žádné dvojité pageviews). Client ID se sdílí přes _ga
   * cookie → event se v GA4 přilepí ke stejnému návštěvníkovi.
   */
  function trackSignup(modal) {
    if (!TEST && ls(SUB_KEY) === '1') return; // dedup: reload success stránky nesmí poslat znovu
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return;
    } catch (e) {}
    var ctx = modal.getAttribute('data-ec-context') || '';
    var lang = modal.getAttribute('data-ec-lang') || '';
    try {
      window.dataLayer = window.dataLayer || [];
      var gtag = function () { window.dataLayer.push(arguments); };
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4_ID;
        document.head.appendChild(s);
      }
      gtag('js', new Date());
      gtag('config', GA4_ID, { send_page_view: false });
      var params = { method: 'popup', ec_context: ctx, locale: lang };
      if (TEST) params.debug_mode = true; // QA přes ?ec_test=1 → vidět v GA4 DebugView
      gtag('event', 'newsletter_signup', params);
    } catch (e) {}
    /* Meta pixel „Lead" — appka Google/Meta posílá jen commerce eventy (Lead v datasetu
     * chybí, ověřeno 2026-07-02). Stejný lazy pattern jako gtag: fbevents.js se nahraje
     * až v momentě úspěchu. Sdílená _fbp cookie → Meta si Lead přilepí ke stejnému
     * prohlížeči jako eventy z appky. Žádný PageView neposíláme → nic se nedvojí.
     */
    try {
      var cpm = window.Shopify && window.Shopify.customerPrivacy;
      if (!(cpm && typeof cpm.marketingAllowed === 'function' && !cpm.marketingAllowed())) {
        var fbq = window.fbq;
        if (!fbq) {
          fbq = window.fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
          if (!window._fbq) window._fbq = fbq;
          fbq.push = fbq;
          fbq.loaded = true;
          fbq.version = '2.0';
          fbq.queue = [];
          var f = document.createElement('script');
          f.async = true;
          f.src = 'https://connect.facebook.net/en_US/fbevents.js';
          document.head.appendChild(f);
        }
        fbq('init', META_PIXEL_ID);
        fbq('track', 'Lead', { content_name: 'newsletter_popup', content_category: ctx });
      }
    } catch (e) {}
    // Stejný event i do Shopify pixel busu — až přibude custom pixel (např. Meta CAPI Lead),
    // odběr už tu bude čekat.
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('newsletter_signup', { method: 'popup', context: ctx, locale: lang });
      }
    } catch (e) {}
  }

  function anotherDialogOpen() {
    var dlgs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dlgs.length; i++) {
      if (!dlgs[i].hasAttribute('data-thtd-ec-modal')) return true;
    }
    return false;
  }

  function openModal() {
    var modal = modalEl();
    if (!modal || modal.open) return;
    // nepřekrývat lokalizační modal / košík — počkej a zkus znovu
    if (anotherDialogOpen()) {
      if (openTries++ < 20) window.setTimeout(openModal, 1500);
      return;
    }
    try { modal.showModal(); } catch (e) { return; }
    if (!TEST) lsSet(SEEN_KEY, String(Date.now()));
  }

  function bindClose() {
    var modal = modalEl();
    if (!modal) return;
    var closeBtn = modal.querySelector('[data-thtd-ec-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    modal.addEventListener('close', function () { if (!TEST) lsSet(SEEN_KEY, String(Date.now())); });
  }

  function personalizeProduct() {
    var modal = modalEl();
    if (!modal || modal.getAttribute('data-ec-context') !== 'product') return;
    var el = document.getElementById('thtd-ec-product');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    if (!data || !data.title) return;
    var en = modal.getAttribute('data-ec-lang') === 'en';
    var titleEl = modal.querySelector('[data-thtd-ec-title]');
    var subEl = modal.querySelector('[data-thtd-ec-sub]');
    if (data.available === false) {
      if (titleEl) titleEl.textContent = en ? (data.title + ' is sold out.') : (data.title + ' je vyprodaný.');
      if (subEl) subEl.textContent = en
        ? 'Leave your email and I’ll let you know the moment it’s back.'
        : 'Nech mi mail a ozvu se, jakmile bude zase skladem.';
    } else if (data.limited === true) {
      if (titleEl) titleEl.textContent = en ? (data.title + ' is a limited run.') : (data.title + ' je limitka.');
      if (subEl) subEl.textContent = en
        ? 'Only a few made, and it won’t return. Leave your email to be first to the next drops.'
        : 'Jen pár kusů a nevrací se. Nech mi mail a budeš u dalších limitek první.';
    } else {
      if (titleEl) titleEl.textContent = en ? ('Like the ' + data.title + '?') : ('Líbí se ti ' + data.title + '?');
      if (subEl) subEl.textContent = en
        ? 'Drop your email. First to new pieces and limited runs. No spam.'
        : 'Nech mi mail. Budeš první u nových kousků a limitek. Žádný spam.';
    }
  }

  function cleanUrl() {
    if (!window.history || !window.history.replaceState) return;
    if (window.location.search.indexOf('customer_posted') === -1) return;
    var qs = window.location.search
      .replace(/([?&])customer_posted=[^&]*&?/, '$1')
      .replace(/[?&]$/, '');
    window.history.replaceState({}, document.title, window.location.pathname + qs + window.location.hash);
  }

  function init() {
    var modal = modalEl();
    if (!modal || typeof modal.showModal !== 'function') return;

    // Po úspěšném přihlášení Shopify znovu vyrenderuje formulář v success stavu →
    // [data-thtd-ec-success] je nejspolehlivější signál (nezávisí na URL paramu).
    if (modal.querySelector('[data-thtd-ec-success]')) {
      trackSignup(modal);
      if (!TEST) lsSet(SUB_KEY, '1');
      bindClose();
      openModal();
      cleanUrl();
      return;
    }

    if (!TEST) {
      if (ls(SUB_KEY) === '1') return;
      var seen = parseInt(ls(SEEN_KEY) || '0', 10);
      if (seen && (Date.now() - seen) < COOLDOWN) return;
    }

    personalizeProduct();
    bindClose();

    var fired = false;
    function tryOpen() {
      if (fired) return;
      fired = true;
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
      openModal();
    }
    function onScroll() {
      var sc = window.scrollY || document.documentElement.scrollTop || 0;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && sc / h >= 0.5) tryOpen();
    }
    function onExit(e) {
      if (e.clientY <= 0 && !e.relatedTarget) tryOpen(); // exit-intent (desktop)
    }
    var timer = window.setTimeout(tryOpen, TEST ? 1200 : 15000);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onExit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
